/**
 * @fileoverview wsdot-travel-times API - Zod Schema Exports
 *
 * This module provides exports for all Zod schemas used in the wsdot-travel-times API.
 * Import these schemas when you need runtime validation in development or testing.
 */

export * from "./travelTimeRoutes/shared/travelTimeRoutes.input";
export * from "./travelTimeRoutes/shared/travelTimeRoutes.output";
